module.exports = __webpack_public_path__ + "img/four.ad7830d9.png";